import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_secured/')({
  loader: async ({ context }) => {
    await context.getInstance('i18n', '@myn/mint-iq');
    await context.getInstance('i18n', '@mint-lib/formatting-hooks');
  },
});
